import axios from "axios";
import { createURL } from "./client";

// getCoinPackages получает список доступных наборов монет
export async function getCoinPackages() {
    return await axios.get(createURL("/api/payments/packages"));
}
